import { useEffect, useState } from "react";
import axios from "axios";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";

import Lesson1 from "./pages/Lesson1";
import Lesson4 from "./pages/Lesson4";
import Lesson5 from "./pages/Lesson5";
import Lesson6 from "./pages/Lesson6";
import Lesson3 from "./pages/Lesson3";
import Lesson2 from "./pages/Lesson2";
import Lesson7 from "./pages/Lesson7";
import Lesson8 from "./pages/Lesson8";
import Lesson10 from "./pages/Lesson10";
import Lesson11 from "./pages/Lesson11";
import Lesson12 from "./pages/Lesson12";
import Lesson13 from "./pages/Lesson13";
import Lesson14 from "./pages/Lesson14";
import Lesson15 from "./pages/Lesson15";
import Lesson16 from "./pages/Lesson16";
import Lesson9 from "./pages/Lesson9";
import Lesson17 from "./pages/Lesson17";
import Lesson18 from "./pages/Lesson18";
import Lesson19 from "./pages/Lesson19";
import Lesson20 from "./pages/Lesson20";
import Lesson21 from "./pages/Lesson21";
import Lesson22 from "./pages/Lesson22";
import Lesson23 from "./pages/Lesson23";


function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const [notconnected, setcheck] = useState<boolean>(true);

  const DISCORD_CLIENT_ID = "1313556316207190218";
  const DISCORD_REDIRECT_URI = process.env.REACT_APP_DISCORD_REDIRECT_URI;
  const GUILD_ID = "1087843967573438504";
  const ROLE_ID = "1156310719172726954";

  const [loginUrl, setLoginUrl] = useState<string>(
    `https://discord.com/api/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&response_type=token&redirect_uri=${DISCORD_REDIRECT_URI}&scope=identify+guilds.members.read`,
  );

  const checkUrlForDiscordToken = async () => {
    const loggedInCookie = document.cookie.split('; ').find(row => row.startsWith('loggedIn='));
    if (loggedInCookie && loggedInCookie.split('=')[1] === 'true') {
      setLoggedIn(true);
      setcheck(false);
      return;
    }
    const fragment = new URLSearchParams(window.location.hash.slice(1));
    const [accessToken, tokenType] = [
      fragment.get("access_token"),
      fragment.get("token_type"),
    ];

    if (accessToken) {
      try {
        const { data } = await axios.get(
          `https://discord.com/api/users/@me/guilds/${GUILD_ID}/member`,
          { headers: { authorization: `${tokenType} ${accessToken}`, }, },
        );
        const hasRole = data.roles.includes(ROLE_ID);
        if (hasRole) {
          setLoggedIn(true);
          setcheck(false);
          document.cookie = "loggedIn=true; path=/";
        } else {
          setLoggedIn(false);
          setcheck(true);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "Self improvement";
    let metaDescription = "self-improvement course by Unity academy";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/lesson1":
        title = "";
        metaDescription = "";
        break;
      case "/lesson37":
        title = "";
        metaDescription = "";
        break;
      case "/lesson4":
        title = "";
        metaDescription = "";
        break;
      case "/lesson5":
        title = "";
        metaDescription = "";
        break;
      case "/lesson6":
        title = "";
        metaDescription = "";
        break;
      case "/lesson3":
        title = "";
        metaDescription = "";
        break;
      case "/lesson2":
        title = "";
        metaDescription = "";
        break;
      case "/lesson7":
        title = "";
        metaDescription = "";
        break;
      case "/lesson8":
        title = "";
        metaDescription = "";
        break;
      case "/lesson10":
        title = "";
        metaDescription = "";
        break;
      case "/lesson11":
        title = "";
        metaDescription = "";
        break;
      case "/lesson12":
        title = "";
        metaDescription = "";
        break;
      case "/lesson13":
        title = "";
        metaDescription = "";
        break;
      case "/lesson14":
        title = "";
        metaDescription = "";
        break;
      case "/lesson15":
        title = "";
        metaDescription = "";
        break;
      case "/lesson16":
        title = "";
        metaDescription = "";
        break;
      case "/lesson9":
        title = "";
        metaDescription = "";
        break;
      case "/lesson17":
        title = "";
        metaDescription = "";
        break;
      case "/lesson18":
        title = "";
        metaDescription = "";
        break;
      case "/lesson19":
        title = "";
        metaDescription = "";
        break;
      case "/lesson20":
        title = "";
        metaDescription = "";
        break;
      case "/lesson21":
        title = "";
        metaDescription = "";
        break;
      case "/lesson22":
        title = "";
        metaDescription = "";
        break;
      case "/lesson27":
        title = "";
        metaDescription = "";
        break;
      case "/lesson31":
        title = "";
        metaDescription = "";
        break;
      case "/lesson32":
        title = "";
        metaDescription = "";
        break;
      case "/lesson28":
        title = "";
        metaDescription = "";
        break;
      case "/lesson30":
        title = "";
        metaDescription = "";
        break;
      case "/lesson23":
        title = "";
        metaDescription = "";
        break;
      case "/lesson24":
        title = "";
        metaDescription = "";
        break;
      case "/lesson26":
        title = "";
        metaDescription = "";
        break;
      case "/lesson29":
        title = "";
        metaDescription = "";
        break;
      case "/lesson25":
        title = "";
        metaDescription = "";
        break;
      case "/lesson38":
        title = "";
        metaDescription = "";
        break;
      case "/lesson39":
        title = "";
        metaDescription = "";
        break;
      case "/lesson41":
        title = "";
        metaDescription = "";
        break;
      case "/lesson43":
        title = "";
        metaDescription = "";
        break;
      case "/lesson45":
        title = "";
        metaDescription = "";
        break;
      case "/lesson46":
        title = "";
        metaDescription = "";
        break;
      case "/lesson47":
        title = "";
        metaDescription = "";
        break;
      case "/lesson40":
        title = "";
        metaDescription = "";
        break;
      case "/lesson44":
        title = "";
        metaDescription = "";
        break;
      case "/lesson42":
        title = "";
        metaDescription = "";
        break;
      case "/lesson33":
        title = "";
        metaDescription = "";
        break;
      case "/lesson34":
        title = "";
        metaDescription = "";
        break;
      case "/lesson35":
        title = "";
        metaDescription = "";
        break;
      case "/lesson36":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag: HTMLMetaElement | null = document.querySelector(
        'head > meta[name="description"]',
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  useEffect(() => {
    if (!loggedIn) {
      checkUrlForDiscordToken();
    } else {
      window.location.hash = "";
    }
  });
  if (loggedIn == false && notconnected == true) {
    return (
      <>
        <div
          className="lmao flex items-center justify-center h-screen"
          style={{
            backgroundColor: "#0d0d0d",
          }}
        >
          <div className="flex items-center justify-center h-full w-full max-md:flex-col">
            <img src="/bg.jpg" className="right" alt="" />
            <div className="w-[60%] h-full mix flex flex-col items-start justify-between remove">
              <img
                src="https://www.unityacademy.io/images/logo.webp"
                className="log w-[250px] z-20 items-start mt-[2rem] ml-[2rem] justify-start"
                alt=""
              />
              <div className="content slide-up ml-[5%] w-[80%] h-full flex flex-col items-start justify-center">
                <p className="text-[3rem] text-white z-20 font-bold font-nunito mt-[-1rem]">
                  Trading Introduction Course
                </p>
                <p className="more text-[1.35rem] font-bold opacity-60 mt-[0rem] font-nunito text-white">
                  Understand all of the key fundamental foundations of the
                  trading basics + much more with our Trading Introduction
                  Course.
                </p>
              </div>
            </div>
            <div className="w-[40%] left flex items-end flex-col justify-between h-full">
              <a
                className=" z-10 shit butt cursor-pointer text-white no-underline nah mt-[2rem] mr-[2rem] rounded-7xl bg-transparent box-border flex flex-col items-center justify-center px-[2rem] py-[0.5rem]  border-[2px] border-solid border-white"
                href="https://unityacademy.io/dashboard"
              >
                <div className="relative font-semibold font-nunito ">Back</div>
              </a>
              <div className="con flex flex-col items-center justify-center w-full h-full max-md:mt-[-7rem]">
                <div className="flex flex-col"></div>
                <p className="disc text-[2.5rem] font-semi text-white font-nunito z-10">
                  Log into your account
                </p>
                <p className="disc text-[1rem] font-semi opacity-60 mt-[-0.5rem] text-white max-md:text-center max-md:mt-2 font-nunito">
                  Connect to Unity Academy Pro to access the course
                </p>
                <a
                  className="shit butt z-10 cursor-pointer text-white no-underline mt-10 mb-10  rounded-7xl bg-transparent box-border gap-6 items-center justify-center px-[4rem] py-[1.3rem] flex max-md:px-[2rem] border-[2px] border-solid border-white"
                  href={loginUrl}
                >
                  <img
                    src="/disc.webp"
                    className="w-[30px] shi max-w-[30px] max-h-[30px]"
                    alt=""
                  />
                  <div className="relative text-[1.2rem] z-10 font-semibold font-nunito ">
                    Log in With Discord
                  </div>
                </a>
                <p className="terms text-white text-[1rem] font-medium opacity-70 font-nunito w-full inline-block">
                  By Logging in, you Agree to our
                  <a href="https://unityacademy.io/legal">
                    <p className="ml-2 underline text-white inline-block cursor-pointer">
                      Terms and Conditions
                    </p>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  if (notconnected == false && loggedIn == false) {
    return (
      <>
        <div
          className="flex flex-col items-center justify-center h-screen"
          style={{
            backgroundColor: "#0d0d0d",
          }}
        >
          <img src="/bg.jpg" className="right tweak" alt="" />
          <p className="more text-[1.35rem] font-semi opacity-80 mt-[0rem] font-nunito text-white text-center">
            You do not have access to the Course
          </p>

          <a
            className="shit butt z-10 cursor-pointer text-white no-underline mt-10 mb-10  rounded-7xl bg-transparent box-border gap-6 items-center justify-center px-[4rem] py-[1.3rem] flex max-md:px-[2rem] border-[2px] border-solid border-white"
            href="https://unityacademy.io/pricing"
          >
            <div className="relative text-[1.2rem] z-10 font-semibold font-nunito ">
              Purchase UnityAcademy Pro
            </div>
          </a>
        </div>
      </>
    );
  } else {
    return (
      <Routes>
        <Route path="/" element={<Lesson1 />} />
        <Route path="/lesson1" element={<Lesson1 />} />
        <Route path="/lesson4" element={<Lesson4 />} />
        <Route path="/lesson5" element={<Lesson5 />} />
        <Route path="/lesson6" element={<Lesson6 />} />
        <Route path="/lesson3" element={<Lesson3 />} />
        <Route path="/lesson2" element={<Lesson2 />} />
        <Route path="/lesson7" element={<Lesson7 />} />
        <Route path="/lesson8" element={<Lesson8 />} />
        <Route path="/lesson10" element={<Lesson10 />} />
        <Route path="/lesson11" element={<Lesson11 />} />
        <Route path="/lesson12" element={<Lesson12 />} />
        <Route path="/lesson13" element={<Lesson13 />} />
        <Route path="/lesson14" element={<Lesson14 />} />
        <Route path="/lesson15" element={<Lesson15 />} />
        <Route path="/lesson16" element={<Lesson16 />} />
        <Route path="/lesson9" element={<Lesson9 />} />
        <Route path="/lesson17" element={<Lesson17 />} />
        <Route path="/lesson18" element={<Lesson18 />} />
        <Route path="/lesson19" element={<Lesson19 />} />
        <Route path="/lesson20" element={<Lesson20 />} />
        <Route path="/lesson21" element={<Lesson21 />} />
        <Route path="/lesson22" element={<Lesson22 />} />

        <Route path="/lesson23" element={<Lesson23 />} />
      </Routes>
    );
  }
}
export default App;
